var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('thead',{staticClass:"is-size-7"},[_c('tr',[_c('th',{staticClass:"has-text-grey-light"}),_c('th',{staticClass:"has-text-grey-light"},[_vm._v("Title")]),_c('th',{staticClass:"has-text-grey-light"},[_vm._v("Audio File")]),_c('th',{staticClass:"has-text-grey-light"},[_vm._v("Songwriters")]),_c('th',{staticClass:"has-text-grey-light"})])])
}]

export { render, staticRenderFns }